import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

// Self-hosted variable fonts (replaces Google Fonts CDN)
import "@fontsource-variable/sora/wght.css"
import "@fontsource-variable/jetbrains-mono/wght.css"

import "@workspace/ui/globals.css"
import App from "./App"

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
